import React from 'react';
import { Alert } from 'reactstrap';

import { useToastHost } from '~libs/toast';

const ToastHost: React.FC = () => {
  const { toasts, removeToast } = useToastHost();

  if (toasts.length === 0) return null;

  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1050, minWidth: '280px' }}>
      {toasts.map((t) => (
        <Alert key={t.id} color={t.type} toggle={() => removeToast(t.id)} className="mb-2 shadow">
          {t.message}
        </Alert>
      ))}
    </div>
  );
};

export default ToastHost;
